import { getColor } from '@lib/common';
import { AiChangeType } from '../../../../ai';
export var getEditBadgeStyles = function getEditBadgeStyles(changeType, theme) {
  switch (changeType) {
    case AiChangeType.Add:
      return {
        badgeBgColor: '#29cc65',
        bg: getColor('fillHighlight4')({
          theme: theme
        }),
        color: 'white',
        border: 'green'
      };

    case AiChangeType.Delete:
      return {
        badgeBgColor: '#e83131ff',
        bg: getColor('fillHighlight2')({
          theme: theme
        }),
        color: 'white',
        border: 'red'
      };

    case AiChangeType.Update:
    default:
      return {
        badgeBgColor: '#f4d144ff',
        bg: getColor('fillHighlight1')({
          theme: theme
        }),
        color: 'white',
        border: 'yellowgreen'
      };
  }
};